<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!--    점검정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검일</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputB_1 }}
        </p>
        <date-selector v-else :readonly="board.readonly" class="w-full flex-1" v-model="form.inputB_1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검장소</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_2 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">재해형태</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_3 }}</p>
        <disaster-class-selector v-else class="w-full flex-1" :readonly="board.readonly" v-model="form.inputB_3" :multiple="true" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">관리주체</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" class="w-full flex-1"/>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검자</div>
        <p v-if="isPrint" class="print-input">소속 {{ form.inputB_5 }} 성명 {{ form.inputB_6 }}</p>
        <div v-else class="flex-1 flex items-center">
          <p class="pr-2">소속</p>
          <ml-input class="w-full flex-1" v-model="form.inputB_5" :readonly="board.readonly" />
          <p class="px-2">성명</p>
          <ml-input class="w-full flex-1" v-model="form.inputB_6" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
      <div v-for="_title in inspectionTitle" :key="`checkbox_${_title}`" class="col-span-1 flex items-center">
        <div v-if="isPrint || board.readonly" class="flex items-center">
          <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
          <span class="flex-1">
            {{ _title }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
          </span>
        </div>
      </div>
    </div>

    <table-inspect-merge
      v-for="(_title, _title_i) in inspectionTitle"
      :key="`inspect_${_title}`"
      v-show="form.inspectChecked.includes(_title)"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="_title"
      table-header-title="점검사항"
      table-header-yes="양호"
      table-header-no="미흡"
      table-header-na="해당없음"
      contentBefore="•"
      v-model="form[`inspectList_${_title_i + 1}`]"
      class="mt-5"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import * as inspectData from "./inspectData";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    DateSelector,
    SignField,
    FileUploadModule,
    TableInspectMerge,
    FieldSelectModule,
    PhotoUploadGridModule,
    DisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      inspectionTitle: ["동절기 건축물 안전점검표", "동절기 터널 안전점검표", "동절기 교량 안전점검표"],

      form: {
        inspectionTitle: "",

        stdInfo: {},
        photoList: [],
        fileList: [],

        inspectChecked: [],
        inspectList_1: inspectData.inspectTable_1,
        inspectList_2: inspectData.inspectTable_2,
        inspectList_3: inspectData.inspectTable_3,

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = value.inspectChecked.join(" ");
        this.$emit("input", value);
      },
    },
  },
  methods: {
    updateListCheck(key, indexRows, text) {
      this.form[key][indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.sign-module::v-deep {
  justify-content: normal !important;
  .sign-field {
    flex: 1;
    max-width: none;
  }
}
</style>
